import { cn } from "@/lib/utils";
import { 
  Users, 
  Trophy,
  MessageCircle,
  X
} from "lucide-react";

export function SocialMenu({ 
  isOpen, 
  onClose,
  onSelectOption
}) {
  if (!isOpen) return null;

  const options = [
    { id: 'friends', icon: Users, label: 'Friends', description: 'View and manage friends' },
    { id: 'leaderboard', icon: Trophy, label: 'Leaderboard', description: 'Global rankings' },
    { id: 'chat', icon: MessageCircle, label: 'Chat', description: 'Chat with players' },
  ];

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[55]"
        onClick={onClose}
      />
      
      {/* Menu Panel */}
      <div 
        className={cn(
          "fixed bottom-20 left-1/2 -translate-x-1/2 z-[60]",
          "w-[90%] max-w-sm",
          "bg-gradient-to-b from-slate-800/98 to-slate-900/98",
          "backdrop-blur-xl rounded-2xl",
          "border border-white/10",
          "shadow-2xl shadow-black/50",
          "animate-in slide-in-from-bottom-4 duration-200"
        )}
        data-testid="social-menu"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <h3 className="text-lg font-bold text-white flex items-center gap-2">
            <Users className="w-5 h-5 text-orange-400" />
            Social
          </h3>
          <button
            onClick={onClose}
            className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
          >
            <X className="w-4 h-4 text-white/70" />
          </button>
        </div>
        
        {/* Options */}
        <div className="p-3 space-y-2">
          {options.map((option) => {
            const Icon = option.icon;
            return (
              <button
                key={option.id}
                onClick={() => {
                  onSelectOption(option.id);
                  onClose();
                }}
                className="w-full flex items-center gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors text-left group"
                data-testid={`social-${option.id}`}
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500/20 to-red-500/20 flex items-center justify-center border border-white/10 group-hover:border-orange-500/30 transition-colors">
                  <Icon className="w-6 h-6 text-orange-400" />
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-white">{option.label}</p>
                  <p className="text-sm text-slate-400">{option.description}</p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
